// extracted by mini-css-extract-plugin
export var button = "serializers-module--button--auWuI buttons--button--OMEYV";
export var darkButton = "serializers-module--darkButton--ddq5W buttons--button--OMEYV buttons--darkButton--Js567";
export var link = "serializers-module--link--NkDMM";
export var videoContainer = "serializers-module--video-container--RSBCM";